<template>
    <KpTooltip :disabled="!tooltip">
        <template #activator="{ on, attrs }">
            <v-btn
                :class="finalBtnClass"
                x-small
                :icon="asIcon"
                :fab="fab"
                :rounded="rounded"
                depressed
                v-bind="{ ...$attrs, ...attrs }"
                v-on="{ ...$listeners, ...on }"
            >
                <KpIcon
                    :size="iconSize"
                    :icon-cls="iconCls"
                    :color="iconColor"
                    :active-color="iconActiveColor"
                    :disabled-color="iconDisabledColor"
                />
            </v-btn>
        </template>
        {{ tooltip }}
    </KpTooltip>
</template>
<script>
/**
 * An icon-only button.
 * Provide 'icon-cls' (e.g. 'far fa-home'), icon-color (e.g. 'white'), tooltip (e.g. 'hello)
 */
export default {
    name: 'IconBtn',
    props: {
        fab: {
            type: Boolean,
            default: true,
        },
        asIcon: {
            type: Boolean,
            default: true,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        iconCls: {
            type: String,
            default: '',
        },
        iconColor: {
            type: String,
            default: null,
        },
        iconActiveColor: {
            type: String,
            default: null,
        },
        iconDisabledColor: {
            type: String,
            default: null,
        },
        iconSize: {
            type: String,
            default: '20',
        },
        tooltip: {
            type: String,
            default: '',
        },
        btnClass: {
            type: [String, Object],
            default: '',
        },
        marginClass: {
            type: String,
            default: 'ma-1',
        },
    },
    data() {
        let btnClass = {};
        if (typeof this.btnClass === 'string') {
            btnClass = `${this.marginClass} ${this.btnClass}`;
        }
        if (this.btnClass instanceof Object) {
            btnClass = { [this.marginClass]: true, ...this.btnClass };
        }
        return {
            finalBtnClass: btnClass,
        };
    },
};
</script>
